import React, { useState, useContext, useEffect } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import TableThird from "../../TableThird/TableThird";
import { usersFromGroupTableOptions } from "../../../constants/tables";
import AccreditationInput from "../../AccreditationInput/AccreditationInput";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { sortData } from "../../../utils/sortData";

const GroupModalTable = ({
  members,
  selectedMembers = [],
  onCheckboxChange,
  isLoadingData,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const { t } = useContext(TranslationsContext);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const filteredUsers = members.filter((user) => {
    const fullName =
      `${user.ime} ${user.prezime} ${user.telefon} ${user.email} ${user.entitet} ${user.pozicija} ${user.grupa?.naziv}`.toLowerCase();
    return fullName.includes(debouncedSearchValue.toLowerCase());
  });

  const mappedUsers = filteredUsers.map((user) => {
    const isSelected = selectedMembers.some(
      (selected) => selected.id === user.id
    );

    const mappedUser = {
      id: user.id,
      className: "group-modal-user",
      checkbox: isSelected, // ← checkbox true/false
    };

    usersFromGroupTableOptions(t).forEach((option) => {
      console.log(option);
      if (option.name === "grupa") {
        mappedUser[option.name] = user.grupa.skracenica;
      } else if (option.name === "celo_ime") {
        mappedUser[option.name] = `${user.ime} ${user.prezime}`;
      } else if (option.name !== "checkbox") {
        const fieldName = option.name.toLowerCase();
        mappedUser[option.name] = user[fieldName];
      }
    });

    return mappedUser;
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const handleSortChange = (field, direction) => {
    setSortField(field);
    setSortDirection(direction);
  };

  return (
    <div className="flex-direction-column gap-12">
      <div className="flex-direction-column  gap-12 width-100">
        <p className="inria-sans-700 font-12" style={{ padding: "0 0 0 14px" }}>
          {t("USERS_TITLE")}
        </p>
        <div
          className="flex-direction-row justify-between width-100  group-modal-table-line"
          style={{ color: "var(--text-black)" }}
        >
          <AccreditationInput
            type="search"
            placeholder={t("SEARCH_PLACEHOLDER")}
            setInputValue={(value) => setSearchValue(value)}
            value={searchValue}
            className="justify-end group-modal-table-search"
          />
        </div>
        <TableThird
          options={usersFromGroupTableOptions(t)}
          forUsers
          onSortChange={handleSortChange}
          sortField={sortField}
          sortDirection={sortDirection}
          data={sortData(mappedUsers, sortField, sortDirection)}
          onCheckboxClick={(value, id) => {
            onCheckboxChange(value, id);
          }}
          isLoadingData={isLoadingData}
          query={debouncedSearchValue}
        />
      </div>
    </div>
  );
};

export default GroupModalTable;
